import React, { useEffect, useState } from "react";
// Other imports remain the same...

export const EasyTrackingModal = () => {
    const [modal, setModal] = useState(sessionStorage.getItem("easyTrackingModal") === "close" ? "close" : "open");
    const [modalInfo, setModalInfo] = useState(null);


    const handleClose = () => {
        sessionStorage.setItem("easyTrackingModal", "close");
        setModal("close");
    };

    useEffect(() => {
        const modalEl = document.querySelector(".modalBackdrop");
        if (modalEl) { // Check if modalEl exists
            modalEl.style.display = modal === "open" ? "block" : "none";
        }
    }, [modal]); // Add modal as a dependency

    useEffect(() => {
        fetch("/getModal")
            .then(res => res.json())
            .then(result => {
                setModalInfo(result);
            });
    }, []);

    return (
        <div className="modalBackdrop">
            <div className="modalScreen">
                <p className="title">ESTADO DE MI PLAN</p>
                <ul>
                    <li>
                    </li>
                    <li>
                        <p>Te invitamos a ingresar desde cualquier dispositivo a esta nueva sección dentro de "Mi Plan", en la que podrás visualizar las distintas etapas del ciclo de vida de tu Plan de Ahorro.</p>
                    </li>
                    <li>
                        <p>La nueva sección "Estado de mi plan" te permitirá:</p>
                    </li>
                    <li>
                        <p>• Conocer el proceso y las diferentes etapas involucradas.</p>
                    </li>
                    <li>
                        <p>• Acceder a información detallada y actualizada.</p>
                    </li>
                    <li>
                    </li>
                </ul>
                <button className="btn-modal" onClick={handleClose}>
                    CERRAR
                </button>
            </div>
        </div>
    );
};
